// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar{width:7px;height:7px;cursor:pointer}::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,.1490196078);border-radius:10px;cursor:pointer}::-webkit-scrollbar-thumb,::-webkit-scrollbar-thumb:hover{background-color:#c1c1c1;border-radius:10px;cursor:pointer}.Avada-ScrollBar--isSubdued ::-webkit-scrollbar{width:5px;height:5px}.Avada-ScrollBar--isSubdued ::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,.0509803922)}", ""]);
// Exports
module.exports = exports;
